// removed by extract-text-webpack-plugin
module.exports = {"filename-wrapper":"filename-wrapper","filename-end":"filename-end","filename":"filename"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/FlexableFileName/flexableFileName.scss
// module id = 1382
// module chunks = 0